export const isEmptyString = (string?: string | number | null) => {
  if (typeof string === 'undefined') return true;
  if (string === null) return true;
  if (typeof string === 'number') return false;
  return string.trim() === '';
};
